/**
 * Validates that internalCOWeightage and externalCOWeightage sum to exactly 1
 */
export const validateCOWeightage = (internalCOWeightage, externalCOWeightage) => {
    const internal = parseFloat(internalCOWeightage) || 0;
    const external = parseFloat(externalCOWeightage) || 0;
    const sum = Math.round((internal + external) * 100) / 100; // Round to avoid floating point issues

    if (sum !== 1) {
        return {
            isValid: false,
            message: `Combined Internal and External CO Weightage must be 1.`
        };
    }

    return { isValid: true, message: '' };
};

/**
 * Validates that directCOWeightage and indirectCOWeightage sum to exactly 1
 */
export const validateDirectIndirectCOWeightage = (directCOWeightage, indirectCOWeightage) => {
    const direct = parseFloat(directCOWeightage) || 0;
    const indirect = parseFloat(indirectCOWeightage) || 0;
    const sum = Math.round((direct + indirect) * 100) / 100;

    if (sum !== 1) {
        return {
            isValid: false,
            message: `Combined Direct and Indirect CO Weightage must be 1.`
        };
    }

    return { isValid: true, message: '' };
};

/**
 * Validates that directPOWeightage and indirectPOWeightage sum to exactly 1
 */
export const validateDirectIndirectPOWeightage = (directPOWeightage, indirectPOWeightage) => {
    const direct = parseFloat(directPOWeightage) || 0;
    const indirect = parseFloat(indirectPOWeightage) || 0;
    const sum = Math.round((direct + indirect) * 100) / 100; 

    if (sum !== 1) {
        return {
            isValid: false,
            message: `Combined Direct and Indirect PO Weightage must be 1.`
        };
    }

    return { isValid: true, message: '' };
};

export const defaultCOPOConfig = {
    coAttainmentMethod: 'THRESHOLD_BASED_ATTAINMENT',
    scoreAveragingBasis: 'ATTEMPTED_STUDENTS',
    // Method-specific configurations
    // SCORE_BASED_ATTAINMENT
    scoreBasedAttainment: {
        level1MinScorePercentage: 50,
        level2MinScorePercentage: 60,
        level3MinScorePercentage: 70,
    },
    // THRESHOLD_BASED_ATTAINMENT
    thresholdBasedAttainment: {
        minScorePercentage: 50,
        level1MinStudentPercentage: 50,
        level2MinStudentPercentage: 60,
        level3MinStudentPercentage: 70,
    },

    internalCOWeightage: 0.3,
    externalCOWeightage: 0.7,
    directCOWeightage: 0.9,
    indirectCOWeightage: 0.1,
    directPOWeightage: 0.9,
    indirectPOWeightage: 0.1,
};
